import { useEffect } from 'react';
import { ShoppingCart } from 'lucide-react';
import { CartCard } from './sections';
import { useDispatch, useSelector } from 'react-redux';
import { useGetCart } from '~/api';
import type { RootState } from '~/redux/store';
import { setCarts } from '~/redux/reducers/cart';
import { EmptyState } from '~/components/ui/EmptyState';
import { useTranslation } from 'react-i18next';
import type { Cart } from '~/graphql/graphql';

export default function Cart() {
  const dispatch = useDispatch();
  const { data } = useGetCart();
  const carts = useSelector((state: RootState) => state.cart);

  useEffect(() => {
    dispatch(setCarts((data?.carts as Cart[]) || []));
  }, [data?.carts, dispatch]);

  const suppliersCount = carts?.carts?.length || 0;
  const itemsCount =
    carts?.carts?.reduce((acc, cart) => acc + (cart.items?.length || 0), 0) ||
    0;

  const { t } = useTranslation('cart');

  return (
    <div className="flex flex-col gap-6">
      <title>{t('cart.title')}</title>
      <div>
        <h1 className="text-2xl sm:text-3xl text-neut-prim mb-2">
          {t('cart.title')}
        </h1>
        <p className="text-sm text-neut-sec">
          {t('cart.count_message', { itemsCount, suppliersCount })}
        </p>
      </div>

      {itemsCount === 0 ? (
        <EmptyState
          icon={<ShoppingCart size={48} />}
          title={t('cart.empty_cart_title')}
          message={t('cart.empty_cart_description')}
        />
      ) : (
        <div className="flex flex-col gap-8">
          {carts.carts?.map((cart: Cart) => (
            <CartCard
              key={cart.id}
              sellingOrganizationId={cart.sellingOrganization.id}
              supplierName={cart.sellingOrganization.name}
              items={cart?.items ?? []}
              id={cart.id}
              supplierLocation={''}
              shippingLocation={cart.shippingLocation}
            />
          ))}
        </div>
      )}
    </div>
  );
}
